import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const irrigationTypesSlice = createSlice({
  name: "irrigationTypes",
  initialState,
  reducers: {
    fetchIrrigationTypesStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchIrrigationTypesSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchIrrigationTypesFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchIrrigationTypesStart,
  fetchIrrigationTypesSuccess,
  fetchIrrigationTypesFailure,
} = irrigationTypesSlice.actions;
export default irrigationTypesSlice.reducer;
